import axios from 'axios';
import {token} from '../services/Authentication'

class QueryCrmService {

  static execute(body) {
  
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL_DATASET}/dynamicdataset/query/test/crm`,
      headers: {        
        "content-type": "application/stream+json",
        "authorization": token(), 
      },
      data: body,
    })
    .then((res) => res, (error) => error)

  }

}


export default QueryCrmService;